"use client";

import Swal from 'sweetalert2';

export function useSweetAlert() {
  return (type, message) => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 7000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    Toast.fire({
      customClass: "z-xxxl",
      icon: type,
      title: message,
    });
  };
}

export function useErrorAlert() {
  return (message) => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'bottom-end',
      background: '#ff5555',
      color: '#fff',
      iconColor: '#fff',
      showConfirmButton: false,
      timer: 10000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: 'error',
      title: message,
    });
  };
}
